<script lang="ts">
    import { _ } from 'svelte-i18n';
    // https://svelte.dev/repl/4c5dfd34cc634774bd242725f0fc2dab?version=3.46.4
    import { clickOutside } from '../../utilities/clickOutside.js';

    import IconDropdown from '../../shared/Icons/IconDropdown.svelte';
    import IconMoreVert from '../../shared/Icons/IconMoreVert.svelte';
    import { Navigation } from '../../utilities/Navigation';
    import { features } from '../../shared/Features/features';
    import ButtonRoundAdd from '../../shared/ButtonRoundAdd.svelte';

    let isDropdownOpen: boolean = false; // default state (dropdown close)

    const handleDropdownClick = () => {
        console.log('handleDropdownClick');
        isDropdownOpen = !isDropdownOpen; // togle state on click
    };

    const handleClickOutside = () => {
        isDropdownOpen = false;
    };
</script>

<div class="menu-dropdown-container">
    <div
        class="dropdown"
        class:clickable={true}
        use:clickOutside
        on:click_outside={handleClickOutside}
    >
        <ButtonRoundAdd on:click={handleDropdownClick} />
        {#if isDropdownOpen}
            <div
                class="menu-list"
                style:visibility={isDropdownOpen ? 'visible' : 'hidden'}
                autofocus
            >
                <button
                    class="button"
                    on:click={() => {
                        isDropdownOpen = false;
                        Navigation.navigate('/upload-file');
                    }}>{$_('Upload file')}</button
                >
                <button
                    class="button"
                    on:click={() => {
                        isDropdownOpen = false;
                        Navigation.navigate('/manual-add-job');
                    }}>{$_('Add job manually')}</button
                >
            </div>
        {/if}
    </div>
</div>

<style>
    :root {
        --menu-background: #6c6b6a;
        --menu-color: #ffffff;
    }
    .menu-dropdown-container {
        position: relative;
        /*position: relative;*/
        /*z-index: 100;*/
        /*z-index: 1000;*/
    }
    .menu-list {
        z-index: 5;
        padding: 8px;
        background-color: white;
        color: black;
        border-radius: 6px;
        font-size: 13px;
        position: absolute;
        right: 0;
        /*left: 0;*/
        top: 35px;
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
        min-width: 130px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        row-gap: 6px;
    }
    .menu-list button {
        list-style: none;
        /*color: white;*/
        min-width: 130px;
        cursor: pointer;
        border-radius: 3px;
        padding: 7px 14px;
        border: 0;
        background-color: inherit;
        text-align: left;
    }
    .menu-list button:hover {
        /*background-color: var(--menu-color);*/
        background-color: var(--main-selected-background);
        /*color: var(--menu-background);*/
    }
    .dropdown {
        /*display: inline-block;*/
        /*position: relative;*/
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 500;
    }
    .clickable {
        cursor: pointer;
    }
</style>
